import IMessage from '../../IMessage';

export enum WifiEvent {
	/**
	 * Wi-Fi was set to CLIENT state.
	 */
	CLIENT_ENABLED = 'client_enabled',

	/**
	 * Wi-Fi is in CLIENT state and have connected to a network.
	 */
	CLIENT_CONNECTED = 'client_connected',

	/**
	 * Wi-Fi is in CLIENT state and failed to connect to a network.
	 */
	CLIENT_CONNECT_REJECTED = 'client_connect_rejected',

	/**
	 * Wi-Fi is in CLIENT state and disconnected from a network.
	 */
	CLIENT_DISCONNECTED = 'client_disconnected',

	/**
	 * Wi-Fi was set to AP state.
	 */
	AP_ENABLED = 'ap_enabled',

	/**
	 * Wi-Fi was set to DISABLED state.
	 */
	DISABLED = 'disabled',
}

type IWifiMessage = IMessage;
export default IWifiMessage;
